<template>
  <div class="yk-stu-manager-new-wrapper clearfix">
    <el-form label-width="80px" class="change-user-password-form">
      <el-form-item label="旧密码">
        <el-input placeholder="请输入旧密码" type="password" v-model="oldPassword" show-password></el-input>
      </el-form-item>
      <el-form-item label="新密码">
        <el-input placeholder="请输入新密码" type="password" v-model="Password" show-password></el-input>
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input placeholder="请确认密码" type="password" v-model="replayPass" show-password></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="editPassword">修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Password: "",
      oldPassword: "",
      replayPass: ""
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.auth;
    }
  },
  created() {},
  methods: {
    editPassword() {
      var that = this;
      if(this.oldPassword == ""){
        that.$message.warning("旧密码不可为空");
        return false;
      }
      if(this.Password == ""){
        that.$message.warning("新密码不可为空");
        return false;
      }
      if(this.replayPass == ""){
        that.$message.warning("请确认密码");
        return false;
      }
      if(this.Password != this.replayPass){
        that.$message.warning("确认密码错误，请重新输入");
        that.replayPass = "";
        return false;        
      }
      this.$http
        .post("/api/XOrg/AOrgInfo/editPassword", {
          Password: this.Password,
          oldPassword: this.oldPassword
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.cancel();
            that.$message.success(rst.msg);
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    cancel(){
      this.Password = "";
      this.oldPassword = "";
      this.replayPass = "";
    }
  }
};
</script>

<style lang="scss">
.yk-stu-manager-new-wrapper{
  .change-user-password-form{
    width: 50%;
  }
}
</style>
